// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/carousel-article-list-item/carousel-article-list-item.component.scss
// module id = 366
// module chunks = 0